import React, { useMemo } from 'react';
import { useData } from '../state/selectors';
import { AllApplicationSteps } from '../types';
import { ApplicationModel, ApplicationStep, ClearerType, HeardAboutInfo } from '@tradingblock/types';
import _ from 'lodash';
import { useFormikContext } from 'formik';

interface ShouldRemoveClearerOptionResponse {
  shouldRemoveClearerOption: boolean;
  clearerType?: ClearerType;
}

export const shouldRemoveClearerOption = (
  selectedHeardAboutUsId: number | string | undefined,
  selectedHeardAboutUsRepId: number | string | undefined,
  heardAboutUsItems: HeardAboutInfo[] | undefined
): ShouldRemoveClearerOptionResponse => {
  if (heardAboutUsItems && selectedHeardAboutUsId !== undefined) {
    const selectedHeardAboutUs = heardAboutUsItems.find(
      heardAboutItem => heardAboutItem.heardAboutId.toString() === selectedHeardAboutUsId
    );
    //Check if there is a rep selected to check if it has RQD office codes
    if (
      selectedHeardAboutUs !== undefined &&
      selectedHeardAboutUs.representatives !== undefined &&
      selectedHeardAboutUs.representatives.length > 0
    ) {
      if (selectedHeardAboutUsRepId !== undefined) {
        const repOfficeCodes = selectedHeardAboutUs.representatives.find(
          rep => rep.repId.toString() === selectedHeardAboutUsRepId
        );
        if (repOfficeCodes !== undefined) {
          if (repOfficeCodes.serviceLevel === 'Skip') {
            let response: { shouldRemoveClearerOption: boolean; clearerType: ClearerType } = {} as any;
            // return true and check the officeCodes for a reference to RQD or Apex
            // return something like this {shouldRemoveClearerOption: true, clearerType: ClearerType.Apex} if apex is found, otherwise return {shouldRemoveClearerOption: true, clearerType: ClearerType.RQD}
            if (repOfficeCodes.officeCodes.apex !== undefined) {
              response = { shouldRemoveClearerOption: true, clearerType: ClearerType.Apex };
            } else if (repOfficeCodes.officeCodes.rqd !== undefined) {
              response = { shouldRemoveClearerOption: true, clearerType: ClearerType.RQD };
            }
            return response;
          } else {
            return { shouldRemoveClearerOption: false, clearerType: undefined };
          }
        }
      }
    } else if (selectedHeardAboutUs !== undefined && selectedHeardAboutUs.officeCodes !== undefined) {
      if (selectedHeardAboutUs.serviceLevel === 'Skip') {
        let response: { shouldRemoveClearerOption: boolean; clearerType: ClearerType } = {} as any;
        if (selectedHeardAboutUs.officeCodes.apex !== undefined) {
          response = { shouldRemoveClearerOption: true, clearerType: ClearerType.Apex };
        } else if (selectedHeardAboutUs.officeCodes.rqd !== undefined) {
          response = { shouldRemoveClearerOption: true, clearerType: ClearerType.RQD };
        }
        return response;
      } else {
        return { shouldRemoveClearerOption: false, clearerType: undefined };
      }
    }
  }
  return { shouldRemoveClearerOption: false, clearerType: undefined };
};

/**
 * A hook that checks what steps should be available base on
 * @returns {ApplicationStep[]} application steps allowed for the app
 */
export function useApplicationSteps() {
  const heardAbout = useData(d => d.ui.heardAbout);
  const context = useFormikContext<ApplicationModel>();

  const allApplicationSteps = useMemo(() => {
    let applicationSteps = _.clone(AllApplicationSteps);

    if (
      context &&
      context.values &&
      shouldRemoveClearerOption(context.values.hearAboutUsId, context.values.repId, heardAbout)
    ) {
      const clearerTypeStepIdIndex = applicationSteps.findIndex(step => step === ApplicationStep.ClearerType);
      if (clearerTypeStepIdIndex) {
        delete applicationSteps[clearerTypeStepIdIndex];
      }
    }
    return applicationSteps;
  }, [heardAbout, context]);

  return allApplicationSteps;
}
